// Etiquetas legibles de los campos sincronizables (clave de BD → nombre
// humano). Se usan en la comparación campo a campo del sync individual
// (RecordSyncPanel), en el detalle por disco del sync masivo (BulkSyncView) y
// en el historial de cambios (RecordChangesPanel), para no mostrar
// identificadores crudos como `LABEL_CATALOG_NR`.
//
// Las claves coinciden con `SYNC_FIELDS` del backend (api/src/data/syncFields.ts)
// y con `record_change.field`. Las etiquetas se traducen (i18n) con las claves
// del namespace `syncFields` del catálogo de idiomas.

/** Tipo de la función `t` de i18next (acotado a lo que usamos aquí). */
type TFunc = (key: string) => string;

/** Campos sincronizables conocidos (clave de BD). */
const SYNC_FIELD_KEYS = new Set<string>([
  'artist',
  'title',
  'edition_year',
  'original_release_year',
  'discogs_genre',
  'discogs_styles',
  'type',
  'label',
  'label_catalog_nr',
  'origin_country',
  'format_tags',
  'discogs_format',
  'barcode',
  'discs_per_album',
  'discogs_notes',
]);

/**
 * Devuelve la etiqueta legible y traducida de un campo sincronizable. Recibe la
 * función `t` de i18next (las vistas la obtienen con `useTranslation`). Si el
 * campo no es conocido, devuelve el propio identificador.
 */
export function fieldLabel(t: TFunc, field: string): string {
  return SYNC_FIELD_KEYS.has(field) ? t(`syncFields.${field}`) : field;
}
